import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng1UpgradedAngularJsWrapper } from './directives/upgrade-wrapper/ng1-upgraded-angular-js.directive';
import { 
  rootScopeProvider,
  smartServiceDeliveryProvider,
  stateProvider,
} from './services/upgraded-providers/ajs-upgraded-providers';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { A18AccordionComponent }  from './controls/a18-accordion/a18-accordion.component';
import { A18DateBoxComponent }  from './controls/a18-date-box/a18-date-box.component';
import { A18ListComponent }  from './controls/a18-list/a18-list.component';
import { A18MenuComponent }  from './controls/a18-menu/a18-menu.component';
import { A18SelectBoxComponent }  from './controls/a18-select-box/a18-select-box.component';
import { A18SchedulerComponent }  from './controls/a18-scheduler/a18-scheduler.component';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SUPPORTED_LANGUAGES } from './settings/language.settings';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import { AnalogClockComponent } from './controls/a18-date-box/analog-clock/analog-clock.component';
import { A18SharedDataService } from './services/downgraded-services/ng-shared-data.service';


@NgModule({
  declarations: [
    Ng1UpgradedAngularJsWrapper,
    A18AccordionComponent,
    A18DateBoxComponent,
    A18ListComponent,
    A18MenuComponent,
    A18SchedulerComponent,
    A18SelectBoxComponent,
    AnalogClockComponent,
  ],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [
    rootScopeProvider,
    stateProvider,
    smartServiceDeliveryProvider,
    // angular material
    //  datepicker
    { provide: MAT_DATE_LOCALE, useValue: SUPPORTED_LANGUAGES.en },
    provideMomentDateAdapter(),
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  exports: [
    Ng1UpgradedAngularJsWrapper,
    A18AccordionComponent,
    A18DateBoxComponent,
    A18ListComponent,
    A18MenuComponent,
    A18SchedulerComponent,
    A18SelectBoxComponent,
    AnalogClockComponent,
  ]
})
export class CoreModule { }

export function bindCoreToAngularJs(angular : any) {
  angular.directive('a18Accordion', downgradeComponent({ component: A18AccordionComponent }));
  angular.directive('a18DateBox', downgradeComponent({ component: A18DateBoxComponent }));
  angular.directive('a18List', downgradeComponent({ component: A18ListComponent }));
  angular.directive('a18Menu', downgradeComponent({ component: A18MenuComponent }));
  angular.directive('a18Scheduler', downgradeComponent({ component: A18SchedulerComponent }));
  angular.directive('a18SelectBox', downgradeComponent({ component: A18SelectBoxComponent }));
  angular.factory('a18sharedDataService', downgradeInjectable(A18SharedDataService));
}
